export const TechVerticalConfig = {
    enrollmentTypes: ['FL-RTT']
};